import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('groupname_version_history'),
    version: defineMessage('version'),
    by: defineMessage('by'),
    accountsLength: defineMessage('length_accounts'),
    search: defineMessage('search_1'),
    name: defineMessage('name'),
    noValuesFound: defineMessage('no_values_found_matching_this_name'),
    noValues: defineMessage('no_values'),
};
